// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionInfo_container__UheFY","info":"SubscriptionInfo_info__v2DZR","bio":"SubscriptionInfo_bio__syvU9","title":"SubscriptionInfo_title__nad8U"};